<template>
  <div>
    <div id="documentocomp" ref="documentocomp" class="font-doc-component"></div>
    <div class="page-error font-doc-component" v-if="error">
      <Error
          title="Não foi possível seguir com a captura"
          :subtitle="errorSubtitulo"
          button-text="Tentar de novo"
          v-bind:callback="callbackErro"
      ></Error>
    </div>
  </div>
</template>

<script>
import AppService from "../../services/AppService";
import Error from "../shared/Error.vue";

export default {
  name: "NewDocDigitalizacao",
  components: {Error},
  data:function (){
    return {
      errorSubtitulo:'',
      error: false,
      userSaiu: false,
    }
  },
  beforeRouteLeave(to, from,next) {
    window.documento.liberaRecursos();
    next();
  },
  created(){
    this.tipoDoc = this.$store.getters.tipoDoc
    this.appService = new AppService();
    this.appService.documentosAceitos(this.tipoDoc);
  },
  mounted() {
    this.$store.dispatch('setLoadingStatus',false);
    this.$store.dispatch('setTitulo','Confirmar identidade');
    if(this.$store.getters.tipoCaptura !== 1){
      this.$router.push({name:'Analise'});
      return;
    }
    if(this.$refs.documentocomp){
      this.appService.preLoadDocumento();
    }      
    this.carregarComponente();
  },
  methods: {
    carregarComponente: function () {
      const elementoHtml = this.$refs.documentocomp;
      if (elementoHtml) {
        window.documento.iniciaCaptura(elementoHtml, (res) => {
        }).then((res) => {
          switch (res.type){
            case 'cnhdig':
            case 'cnhdig2022':
              this.$store.dispatch('setCNHDigital', res.image);
              break;
            default:
              sessionStorage.setItem('A', res.image[0])
              sessionStorage.setItem('B', res.image[1])
              break;
            }
          this.$router.push({name: "Analise"});
        })
        .catch((err) => {
          this.error = true;
          this.errorSubtitulo = err.desc
          if(err.id === 300){
            this.userSaiu = true;
          }
        });
      }
    },
    callbackErro: function (){
      window.location.reload()
      return;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/NewDocDigitalizacao.vue